export default "__VITE_ASSET__5a785330__"